import varint from 'varint';
import { toString as uint8ArrayToString } from 'uint8arrays/to-string';
import { concat as uint8ArrayConcat } from 'uint8arrays/concat';
import { nameToVarint } from './maps';

const uint8ArrayToNumber = (buf: Uint8Array) => {
  return parseInt(uint8ArrayToString(buf, 'base16'), 16);
};

const varintUint8ArrayEncode = (input: Uint8Array) => {
  return Uint8Array.from(varint.encode(uint8ArrayToNumber(input)));
};

export const addPrefix = (
  multicodecStrOrCode: string | Uint8Array,
  data: Uint8Array
) => {
  let prefix;

  if (multicodecStrOrCode instanceof Uint8Array) {
    prefix = varintUint8ArrayEncode(multicodecStrOrCode);
  } else {
    if (nameToVarint[multicodecStrOrCode]) {
      prefix = nameToVarint[multicodecStrOrCode];
    } else {
      throw new Error('multicodec not recognized');
    }
  }

  return uint8ArrayConcat([prefix, data], prefix.length + data.length);
};

export const removePrefix = (data: Uint8Array) => {
  varint.decode(data);
  return data.slice(varint.decode.bytes);
};
